import { createCrudService } from "@dgs/core";
import { UserCreateDto, UserListDto, UserOptionDto, UserShowDto, UserUpdateDto } from "apiGen";

export const usersService = createCrudService<UserListDto, UserOptionDto, UserShowDto, UserCreateDto, UserUpdateDto>([
	"users",
]);
